// src/games/Quiz/Sidebar/index.tsx
import { FaStopwatch, FaTrophy } from 'react-icons/fa';

import Switch from '../../../components/SwitchTheme';
import { useThemeApp } from '../../../hooks/theme';
import type { iQuiz } from '../../../interfaces/quiz';
import { formatClock } from '../../core/session/time';
import { Button, Container, Content, Footer, Header } from './styles';

interface SidebarProps {
  maxScore: number;
  currentScore: number;
  seconds: number;
  quiz?: iQuiz;
  canAnswer: boolean;
  onAnswer: (alternativeIndex: number) => void;
  onRestart?: () => void;
}

const LETTERS = ['A', 'B', 'C', 'D', 'E', 'F'];
const HEADER_COLOR =
  'linear-gradient(90deg, rgba(127,71,136,1) 4%, rgba(84,173,72,1) 50%, rgba(84,173,72,1) 100%)';
const HOVER_COLOR = '#7f4788';

export const Sidebar = ({ maxScore, currentScore, seconds, quiz, canAnswer, onAnswer, onRestart }: SidebarProps) => {
  const { isDark } = useThemeApp();

  return (
    <Container>
      <Header counterColor="#222324" headerColor={HEADER_COLOR}>
        <span>
          <p>
            <FaStopwatch size={20} />
            {formatClock(seconds)}
          </p>
          <p>
            <FaTrophy size={20} />
            {currentScore}/{maxScore} PTS
          </p>
        </span>
      </Header>
      <Content>
        {onRestart && (
          <Button hoverColor={HOVER_COLOR} onClick={onRestart}>
            <p>RECOMEÇAR</p>
          </Button>
        )}

        <p
          style={{
            width: '15rem',
            height: '1px',
            background: isDark ? '#fff' : '#000',
            opacity: 0.4,
            margin: '1.25rem auto',
          }}
        />

        {quiz?.alternatives.map((alternative, index) => (
          <Button
            hoverColor={HOVER_COLOR}
            onClick={() => onAnswer(index)}
            disabled={!canAnswer}
            key={`${quiz.id_quiz}-${index}`}
          >
            <p className="alternative">{LETTERS[index]}.</p>
            <p>{alternative.alternative}</p>
          </Button>
        ))}
      </Content>
      <Footer backgroundColor="#54ad48" isDark={isDark}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Switch />
        </div>
      </Footer>
    </Container>
  );
};
